import api from '@/api';
import LeftGroupList from '@/components/LeftGroupList.vue';
import OpticalPathBoard from '@/components/subject/OpticalPathInference/OpticalPathBoard.vue';
export default {
  name: 'OpticalPathQuestionSelector',
  components: {
    LeftGroupList,
    OpticalPathBoard
  },
  emits: ['confirm'],
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      total: 0,
      page: 0,
      pageSize: 20,
      loading: false
    };
  },
  methods: {
    images(value) {
      try {
        return value ? JSON.parse(value) : [];
      } catch (e) {
        return [];
      }
    },
    config(question) {
      if (!question?.opticalConfig) return null;
      try {
        return typeof question.opticalConfig === 'string' ? JSON.parse(question.opticalConfig) : question.opticalConfig;
      } catch (e) {
        return null;
      }
    },
    onChoose(groupId) {
      this.groupId = groupId;
      this.page = 0;
      this.fetchQuestions();
    },
    fetchQuestions() {
      if (!this.groupId) {
        this.questions = [];
        this.total = 0;
        return;
      }
      this.loading = true;
      api.getOpticalPathQuestions({
        groupId: this.groupId,
        enabled: true,
        page: this.page,
        pageSize: this.pageSize
      }).then(result => {
        this.questions = result.list;
        this.total = result.total;
      }).finally(() => {
        this.loading = false;
      });
    },
    init() {
      api.getOpticalPathGroups().then(groups => {
        this.groups = groups;
        this.groupId = groups.length ? groups[0].value : null;
        this.page = 0;
        this.fetchQuestions();
      });
    }
  },
  mounted() {
    this.init();
  }
};